/**
 * Summary
 * The global Sidebar component is responsible for displaying context-
 * dependent information. It should be able to display articles, current
 * events, and other specific information. It is context-aware in that
 * other events can trigger the Sidebar's display state and contents.
 */

import React, { useEffect } from "react";
import { useApp } from "../_contexts";
import { IconButton } from "../_components";

import {
  SidebarEventDetails,
  SidebarRangeDetails,
  SidebarBundleDetails,
  SidebarLocationDetails,
  SidebarChronicleDetails,
} from "./";

export function Sidebar() {
  const { sidebarOpen, closeSidebar, sidebarProps } = useApp();

  let body = null;

  const handleClose = () => {
    //We pass false to ensure the content is preserved
    closeSidebar(false);
  };

  // useEffect(() => {
  if (sidebarProps && sidebarProps.props) {
    const { type, payload } = sidebarProps.props;
    console.log("Loading Sidebar", type, payload);

    switch (type) {
      case "event": {
        body = <SidebarEventDetails item={payload.event} />;
        break;
      }
      case "range": {
        body = <SidebarRangeDetails item={payload.event} />;
        break;
      }
      case "bundle": {
        body = <SidebarBundleDetails bundle={payload.bundle} />;
        break;
      }
      case "locationMarker": {
        body = <SidebarLocationDetails marker={payload.marker} />;
        break;
      }
      case "chronicle": {
        body = <SidebarChronicleDetails />;
        break;
      }
      default: {
        body = null;
        break;
      }
    }
  }
  // }, [sidebarProps]);

  let className = "chronos-sidebar";
  if (sidebarOpen) {
    // console.log('SidebarProps', sidebarProps);
    className += " chronos-sidebar-open";
  }

  useEffect(() => {
    const handleKeyTrigger = (ev) => {
      // console.log('KEY PRESSED', ev.key);
      if (ev.key === "Escape") {
        closeSidebar(false);
      }
    };
    if (sidebarOpen) {
      window.addEventListener("keyup", handleKeyTrigger);
    } else {
      window.removeEventListener("keyup", handleKeyTrigger);
    }

    return () => window.removeEventListener("keyup", handleKeyTrigger);
  }, [sidebarOpen]);

  return (
    <div className={className}>
      <div className="chronos-sidebar-head">
        <IconButton icon="fas fa-times" iconOnly onClick={handleClose} />
      </div>
      {body}
    </div>
  );
}
